module.exports = __webpack_public_path__ + "static/media/riskstep1.5c551405.svg";